import script from "./PortfolioSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./PortfolioSection.vue?vue&type=script&setup=true&lang=ts"

import "./PortfolioSection.vue?vue&type=style&index=0&id=5f847710&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f847710"]])

export default __exports__